import React, {useEffect, useState} from 'react';
import {onConnectionChange} from '../api';

export default function ConnectionBanner() {
  const [offline, setOffline] = useState(false);
  useEffect(() => onConnectionChange(setOffline), []);
  if (!offline) return null;
  return (
    <div className="bg-red-600 text-white text-center py-2 text-sm font-medium fixed top-0 left-0 right-0 z-50">
      Connection lost. Trying to reconnect...
    </div>
  );
}
